'use client'

import type { MouseEventHandler, ReactNode } from 'react'

interface PrimaryGradientButtonProps {
  text: ReactNode
  noShadow?: boolean
  handleClick?: MouseEventHandler<HTMLButtonElement>
}

function PrimaryGradientButton({ text, noShadow, handleClick }: PrimaryGradientButtonProps) {
  return (
    <button
      className="btn-primary-gradient"
      style={{ boxShadow: noShadow ? 'none' : '' }}
      onClick={handleClick}
    >
      {text}
    </button>
  )
}

export default PrimaryGradientButton
